<!-- 审批申请单 -->
<template>
  <div class="app-container">
    <Table
      ref="tableRef"
      :showSearchIcon="true"
      :data="tableData"
      :columns="columns"
      :total="total"
      :loading="loading"
      :searchAttrName="searchAttrName"
      rowKey="applicationFormId"
      :isExpand="true"
      :childColumns="childColumns"
      @expandOpen="handleExpandOpen"
      @onSearch="handleSearch"
    >
    </Table>
    <Dialog
      title="驳回"
      v-model="rejectDialogOpen"
      @onConfirm="handleRejectConfirm"
    >
      <template #content>
        <el-form>
          <el-form-item label="驳回理由:" style="margin: 0px">
            <el-input
              v-model="rejectRemarks"
              placeholder="请输入驳回理由"
            ></el-input>
          </el-form-item>
        </el-form>
      </template>
    </Dialog>
  </div>
</template>

<script setup>
import Table from "@/components/Element/Table";
import Dialog from "@/components/Element/Dialog";
import { ref } from "vue";
import { getCustomTableCols } from "@/tableColumn";
import {
  listApplicationForm,
  approvalApplicationForm,
  rejectApplicationForm,
} from "@/api/warehouse/applicationForm";
import { selectProductRecordsByApplicationFormId } from "@/api/warehouse/outInWarehouse";
import useCacheStore from "@/store/modules/cache";
import { isNull } from "@/utils/fangerUtils";
import { succesMsg } from "@/utils/msgBox";
const cacheStore = useCacheStore();

const { getProductById } = cacheStore;

/**仅支持 Vue 3.3+  配置name 为了是 keep-alive :include 生效 */
defineOptions({
  name: "approval",
});

const tableData = ref([]);
const tableRef = ref(null);

const total = ref(0);
const loading = ref(false);

const searchAttrName = ["name", "applicant", "type", "outInStatus"];

// 搜索
const handleSearch = (data) => {
  loading.value = true;
  listApplicationForm({
    ...data,
    approvalStatus: "0", // 待审批
  })
    .then((res) => {
      tableData.value = res.data;
      total.value = res?.pageParam?.totleInfo ? res.pageParam.totleInfo : 0;
    })
    .catch((res) => {})
    .finally(() => {
      loading.value = false;
    });
};

// 查询展开数据
const handleExpandOpen = (row) => {
  if (!isNull(row.childTableData)) return;
  row.childTableLoading = true;
  selectProductRecordsByApplicationFormId(row.applicationFormId)
    .then((res) => {
      const childTableData = [];
      res.data.forEach((item) => {
        childTableData.push({
          ...getProductById(item.productId),
          ...item,
        });
      });
      row.childTableData = childTableData;
    })
    .catch(() => {})
    .finally(() => {
      row.childTableLoading = false;
    });
};

// 审批
const handleApproval = (event, row) => {
  approvalApplicationForm(row.applicationFormId)
    .then(() => {
      succesMsg("审批成功");
      tableRef.value.onSearch();
    })
    .catch(() => {});
};

// 驳回
const rejectDialogOpen = ref(false);
const rejectRemarks = ref("");
let rejectRow = null;
const handleReject = (event, row) => {
  rejectRow = row;
  rejectRemarks.value = "";
  rejectDialogOpen.value = true;
};

const handleRejectConfirm = () => {
  rejectApplicationForm(rejectRow.applicationFormId, rejectRemarks.value)
    .then((res) => {
      succesMsg("驳回成功");
      rejectDialogOpen.value = false;
      tableRef.value.onSearch();
    })
    .catch(() => {});
};

const columns = getCustomTableCols([
  "name",
  "applicant",
  "applicationTime",
  "applicationFormType",
  "outInStatus",
  {
    label: "操作",
    prop: "action",
    type: "action",
    search: false,
    action: [
      {
        control: "button",
        controlName: "审批",
        controlType: "danger",
        controlText: true,
        controlFun: handleApproval,
      },
      {
        control: "button",
        controlName: "驳回",
        controlType: "danger",
        controlText: true,
        controlFun: handleReject,
      },
    ],
  },
]);

const childColumns = getCustomTableCols([
  "productName",
  "productNum",
  "productType",
  "supplierp",
  "supplierModel",
  "internalModel",
  "usageType",
]);
</script>

<style lang="scss" scoped></style>
